import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../lib/helpers';

import Topbar from '../../components/Topbar/Topbar';

import { CaretLeftIcon } from '../../images/shapes';

const PoppingPageLayout = ({
  title,
  buttons,
  buttonsDisabled = false,
  children,
  status,
  noPaddings,
  onBack,
  testId = '',
}) => {
  return (
    <div className="relative h-full w-full pb-10 lg:pb-0">
      <Topbar
        topbarHeading={title || ''}
        buttons={buttons}
        buttonsDisabled={buttonsDisabled}
        status={status}
        beforeHeading={
          <button
            onClick={onBack}
            type="button"
            className="inline-flex py-2 pr-4"
          >
            <CaretLeftIcon className="w-2.5 text-blue" />
          </button>
        }
        additionalClasses="fixed"
        {...getTestProps(testId, 'topbar', 'testId')}
      />
      <div className="flex items-stretch w-full min-h-[calc(100vh-71px)] pt-[56px]">
        <div className="flex flex-col w-full">
          <div
            className={twMerge('h-full relative', !noPaddings && 'p-4 lg:p-7 ')}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoppingPageLayout;

PoppingPageLayout.propTypes = {
  /**
   * Page title shown in helmet and topbar
   */
  title: PropTypes.string.isRequired,
  /**
   * Topbar buttons
   */
  buttons: PropTypes.node,
  /**
   * If topbar buttons are disabled
   */
  buttonsDisabled: PropTypes.bool,
  /**
   * Content object status
   */
  status: PropTypes.string,
  /**
   * If page should not have paddings
   */
  noPaddings: PropTypes.bool,
  /**
   * Function to call on back button click
   */
  onBack: PropTypes.func.isRequired,
  /**
   * Component test id
   */
  testId: PropTypes.string,
};
